import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiGet } from '../../../../api/queries/apiGet';
import { TEMPLATES_BASE_URL } from '../consts';
import { policyTemplatesQueryKeys } from '../queryKeys';
import { PolicyTemplateCategory } from '../../Templates/types/category';

const END_POINT = '/categories';

type PolicyTemplateCategoryDto = PolicyTemplateCategory;

const transformPolicyTemplateCategoryDtoToPolicyTemplateCategory = (
    dto: PolicyTemplateCategoryDto
): PolicyTemplateCategory => {
    return {
        id: dto.id,
        name: dto.name,
        backgroundColor: dto.backgroundColor
    };
};

const fetchCategories = async (): Promise<PolicyTemplateCategoryDto[]> => {
    const data = await apiGet<PolicyTemplateCategoryDto[]>(`${TEMPLATES_BASE_URL}${END_POINT}`);
    return data;
};

export const useGetPolicyTemplateCategories = (): UseQueryResult<PolicyTemplateCategory[]> => {
    return useQuery({
        queryKey: policyTemplatesQueryKeys.categories(),
        queryFn: fetchCategories,
        select: (data) => data.map(transformPolicyTemplateCategoryDtoToPolicyTemplateCategory)
    });
};
